import { Button, IconReload16, UIHeading4 } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './CurrentAreaSearch.css';

type CurrentAreaSearchProps = {
  handleClick: VoidFunction;
};

export const CurrentAreaSearch: FC<CurrentAreaSearchProps> = props => {
  const { handleClick } = props;

  return (
    <div className={styles['current-area-search-wrapper']}>
      <Button
        beforeIcon={
          <>
            <IconReload16 color="black_100" />
            <span className={styles['current-area-search-text']}>
              <UIHeading4 color="black_100">Искать в этой области</UIHeading4>
            </span>
          </>
        }
        data-testid="map-controls.area-search"
        size="M"
        theme="fill_white_primary"
        onClick={handleClick}
      />
    </div>
  );
};
